import { createReducer } from '@reduxjs/toolkit';

import { StatisticsLoginInit } from 'redux/reducers/init';

import {
  requestStatisticsLogin,
  requestStatisticsLoginSuccess,
  requestStatisticsLoginFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsLogin = createReducer(StatisticsLoginInit, {
  [requestStatisticsLogin.type]: (state, action: RequestStatisticsLoginAction) => {
    state.isLoading = true;
  },
  [requestStatisticsLoginSuccess.type]: (state, action: RequestStatisticsLoginSuccessAction) => {
    const { statisticsLogin } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsLogin;
  },
  [requestStatisticsLoginFailure.type]: (state, action: RequestStatisticsLoginFailureAction) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsLogin;
